import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a497d714"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay remove-margin" }
const _hoisted_2 = { class: "gem-messages-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reverse-background-gradient" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "base" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "header" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_CircleAvatar = _resolveComponent("CircleAvatar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_GemMessage = _resolveComponent("GemMessage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header, {
        justify: "space-between",
        class: "log-details-header",
        title: "",
        backLink: _ctx.GEM_LOGS_ROUTE
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { class: "friend-name-container" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_row, { class: "friend-displayname" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.friend.displayName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_row, { class: "friend-username" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, "@" + _toDisplayString(_ctx.friend.username), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_CircleAvatar, {
                class: "friend-avatar",
                avatarUrl: _ctx.friend.avatar,
                radius: 2.5
              }, null, 8, ["avatarUrl", "radius"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["backLink"]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gemsAndIsSentBySelf, (gemAndIsSentBySelf) => {
          return (_openBlock(), _createBlock(_component_GemMessage, {
            key: gemAndIsSentBySelf.gem.id,
            gem: gemAndIsSentBySelf.gem,
            isSentBySelf: gemAndIsSentBySelf.isSentBySelf
          }, null, 8, ["gem", "isSentBySelf"]))
        }), 128))
      ])
    ]),
    _hoisted_3
  ]))
}